import React from 'react';

interface ExclamationMarkProps {
  className?: string;
  dataTestId?: string;
}

const ExclamationMark = ({ className, dataTestId }: ExclamationMarkProps) => (
  <svg width={24} height={24} viewBox="0 0 20 20" className={className} data-testid={dataTestId}>
    <path
      fill="#A61A30"
      fillRule="evenodd"
      d="M10 17.5c-4.136 0-7.5-3.364-7.5-7.5S5.864 2.5 10 2.5s7.5 3.364 7.5 7.5-3.364 7.5-7.5 7.5m0-16c4.687 0 8.5 3.813 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5-4.687 0-8.5-3.813-8.5-8.5 0-4.687 3.813-8.5 8.5-8.5zm0 11.525a.834.834 0 0 0 0 1.667.835.835 0 0 0 0-1.667zm0-.925a.5.5 0 0 0 .5-.5V5.2a.5.5 0 0 0-1 0v6.4a.5.5 0 0 0 .5.5z"
    />
  </svg>
);

export default ExclamationMark;
